import React from 'react';
import { Sparkles, FileText, RefreshCw, Lightbulb, ArrowRight, X } from 'lucide-react';
import './IntegrationPrompt.css';

const IntegrationPrompt = ({ onChoice, onCancel, wizardAData, wizardBData, wizardCData }) => {
  const hasWizardA = wizardAData?.intake?.researchType || wizardAData?.philosophy || wizardAData?.strategy;
  const hasWizardB = wizardBData?.researchQuestions?.length > 0 || wizardBData?.variables?.length > 0;
  const hasWizardC = wizardCData?.constructs?.length > 0;

  const getSummary = () => {
    const items = [];
    if (wizardAData?.intake?.researchType) {
      items.push(`Research Type: ${wizardAData.intake.researchType}`);
    }
    if (wizardAData?.philosophy) {
      items.push(`Paradigm: ${wizardAData.philosophy}`);
    }
    if (wizardAData?.strategy) {
      items.push(`Strategy: ${wizardAData.strategy}`);
    }
    if (wizardBData?.researchQuestions?.length > 0) {
      items.push(`${wizardBData.researchQuestions.length} research question(s) defined`);
    }
    if (wizardBData?.variables?.length > 0) {
      items.push(`${wizardBData.variables.length} variable(s) identified`);
    }
    if (wizardCData?.constructs?.length > 0) {
      items.push(`${wizardCData.constructs.length} construct(s) in framework`);
    }
    return items;
  };

  const summaryItems = getSummary();

  return (
    <div className="integration-prompt">
      <button className="integration-close" onClick={onCancel}>
        <X size={24} />
      </button>
      
      <div className="integration-header">
        <div className="integration-icon">
          <Sparkles size={32} />
        </div>
        <h2>We Found Your Previous Research Design</h2>
        <p>Would you like to use your choices from Wizards A, B, and C as a starting point?</p>
      </div>

      <div className="integration-summary">
        <h4>Your Research Design Includes:</h4>
        <ul>
          {summaryItems.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </div>

      <div className="integration-options">
        <button 
          className="integration-option use-data"
          onClick={() => onChoice('use')}
        >
          <div className="option-icon">
            <Lightbulb size={24} />
          </div>
          <div className="option-content">
            <h3>Use as Starting Point</h3>
            <p>Pre-populate questions based on your research design and get smart recommendations</p>
          </div>
          <ArrowRight size={20} className="option-arrow" />
        </button>

        <button 
          className="integration-option guidance-only"
          onClick={() => onChoice('guidance')}
        >
          <div className="option-icon">
            <RefreshCw size={24} />
          </div>
          <div className="option-content">
            <h3>Show as Guidance Only</h3>
            <p>Display your design choices as reference while building a new questionnaire</p>
          </div>
          <ArrowRight size={20} className="option-arrow" />
        </button>

        <button 
          className="integration-option fresh-start"
          onClick={() => onChoice('fresh')}
        >
          <div className="option-icon">
            <FileText size={24} />
          </div>
          <div className="option-content">
            <h3>Start Fresh</h3>
            <p>Create a completely new questionnaire without any pre-populated data</p>
          </div>
          <ArrowRight size={20} className="option-arrow" />
        </button>
      </div>
    </div>
  );
};

export default IntegrationPrompt;
